import {map} from 'lodash';
import i18n from 'src/i18n';
import {columnsFn} from './utils';

export const columns = columnsFn({
  disease: {
    type: 'select', multi: true,
    items: map(Object.keys(i18n.s('fields.medical_histories.disease')), x => 'fields.medical_histories.disease.' + x),
  },
  currentStatus: {
    type: 'select', multi: true,
    items: map(Object.keys(i18n.s('fields.medical_histories.currentStatus')), x => 'fields.medical_histories.currentStatus.' + x),
  },
  otherDisease: {type: 'string'},
  doneSurgery: {type: 'checkbox'},
  surgery: {type: 'string'},
  mentalTreatment: {type: 'checkbox'},
  useService: {type: 'string'},
});

export function title(model) {
  return model ? model.name : '';
}



// WEBPACK FOOTER //
// ./src/schemas/medical_history.js